import { React, useState, useEffect } from 'react';
import "./Devices.css";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Container } from 'react-bootstrap';
import { Title, Device, LinkBtn } from '../../../../Components';
// import { Device } from "../../index";
import axios from "axios";
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material';
import { ListItem, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import no_image from "../../../../assets/Images/no-image.png"


const Devices = ({ url, section, homeLoading, fromDetails = false }) => {

    const [loading, setLoading] = useState(true);
    const [devicesData, setData] = useState([]);
    const resultsPerPage = 10;

    const [compareList, setCompareList] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isFirstOpen, setIsFirstOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (compareList.length > 0) {
            setIsVisible(true);
            if (compareList.length === 1) {
                setIsFirstOpen(true);
            }
        } else if (isVisible) {
            setTimeout(() => setIsVisible(false), 10);
        }
    }, [compareList]);

    const handleRemoveItem = (name) => {
        setCompareList((prev) => prev.filter((item) => item.name !== name));
    };


    const handleCompare = () => {
        // navigate('/CompareDevices', { state: { compareList } });
        // omarg
        // removed state and used localstorage instead
        localStorage.setItem("compareList", JSON.stringify(compareList));
        navigate('/CompareDevices');
    };



    useEffect(() => {
        if ((homeLoading == false && section && loading) || (homeLoading == false && loading && fromDetails))
            setTimeout(() => {
                fetchData();
            }, 1500);
    }, [homeLoading]);



    const fetchData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const start = (pageNumber - 1) * resultsPerPage;
            let apiUrl = `${url}/api/method/webshop.webshop.doctype.website_item.website_item.items?start=${start}&limit=${resultsPerPage}&item_group=Tracking Devices`;
            const response = await axios.get(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.data.status_code !== 200) {
                toast.error("Failed to fetch data. Please try again..");
            }
            const result = response.data.result;
            setData(result.objects);
            setLoading(false);
        } catch (error) {
            toast.error("Failed to fetch data. Please try again..");
            setLoading(false);
        }
    };

    return (
        <div className='devices'>
            <Container>
                <Title
                    title={"Our Feature Devices"}
                    overlay={"Devices"}
                />
            </Container>


            {loading ? (<>


                <div className="skeleton-splide">
                    <Splide
                        options={{
                            type: "slide",
                            arrows: false,
                            pagination: false,
                            perPage: 5,
                            perMove: 1,
                            autoWidth: true,

                        }}

                    >
                        {Array.from({ length: 7 }).map((_, index) => (
                            <SplideSlide>
                                <div key={index} >
                                    <Skeleton className="device-container-skelton" animation="wave" variant="rectangular" />
                                    <Skeleton animation="wave" />
                                    <Skeleton animation="wave" width="60%" />
                                </div>
                            </SplideSlide>

                        ))}
                    </Splide>
                </div>
                {/* <ReactLoading type="spinningBubbles" width="50px" color="#239DAB" className='spinner-loading' /> */}
            </>) : (
                <>
                    <div className='devices-slider'>

                        <Splide
                            options={{
                                type: "slide",
                                arrows: fromDetails ? false : true,
                                pagination: false,
                                gap: "25px",
                                perPage: 5,
                                autoWidth: true,
                                perMove: 1,
                            }}

                        >
                            {devicesData && devicesData.map((item, index) => (
                                <SplideSlide key={index}>
                                    <a href={`/productdetails?item_name=${item.name}`}>
                                        <Device
                                            url={url}
                                            company={item.brand_image}
                                            image={item.website_image}
                                            name={item.name}
                                            website_name={item.web_item_name}
                                            properties={item.properties}
                                            type={item.item_group}
                                            isNew={item.isNew}
                                            short_description={item.short_description}
                                            compareList={compareList}
                                            setCompareList={setCompareList}
                                        />
                                    </a>
                                </SplideSlide>
                            ))}

                        </Splide>
                    </div>
                    <LinkBtn
                        link={"/products"}
                        titleLink={"See All Devices"}
                    />
                </>


            )}


            {isVisible && (
                <div className={`compare-items-container ${isFirstOpen ? 'slide-up' : 'slide-down'}`}>
                    <Container>
                        <div className='content'>
                            <div className='content-text'>
                                <div className='text'>Compare</div>
                                <div className='text1'>Up to 4 products</div>
                            </div>

                            <div className='compare-row'>
                                {compareList.map((selectedDevice, index) => (
                                    <ListItem
                                        className={`compare-item-card`}
                                        key={selectedDevice.name}
                                    >
                                        {selectedDevice.image != null ? (
                                            <img
                                                className="list-option-image"
                                                src={url + '/' + selectedDevice.image}
                                                alt={selectedDevice.website_name}
                                            />
                                        ) : (
                                            <img
                                                className="list-option-image null-image"
                                                src={no_image}
                                                alt={selectedDevice.website_name}
                                            />
                                        )}

                                        <ListItemText
                                            className='text'
                                            primary={
                                                <span className="website-item-text" title={selectedDevice.website_name}>
                                                    {selectedDevice.website_name.length > 15
                                                        ? `${selectedDevice.website_name.slice(0, 15)}...`
                                                        : selectedDevice.website_name}
                                                </span>
                                            }
                                        />

                                        <div onClick={() => handleRemoveItem(selectedDevice.name)} className='unselect-device-icon'>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="15"
                                                height="14"
                                                viewBox="0 0 15 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1 1L14 13M1 13L14 1"
                                                    stroke="#B5B5B5"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </ListItem>
                                ))}
                            </div>

                            <button
                                className="compare-btn"
                                style={{ 
                                    cursor: compareList.length >= 2 ? 'pointer' : 'not-allowed',
                                    opacity: compareList.length >= 2 ? 1 : 0.6
                                }}
                                onClick={handleCompare}
                                disabled={compareList.length < 2}
                            >
                                COMPARE NOW
                            </button>
                        </div>
                    </Container>
                </div>
            )}
        </div>

    );
}

export default Devices;
